'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'calendar';
var width = 448;
var height = 512;
var aliases = [128197,128198];
var unicode = 'f133';
var svgPathData = ['M16 192l416 0 0 272-416 0 0-272z', 'M128 0l0 64 192 0 0-64 16 0 0 64 112 0 0 416-448 0 0-416 112 0 0-64 16 0zM112 104l0-24-96 0 0 96 416 0 0-96-96 0 0 32-16 0 0-32-192 0 0 32-16 0 0-8zm320 88l-416 0 0 272 416 0 0-272z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCalendar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;